module.exports = __webpack_public_path__ + "img/tmf-icon-M-rounded.803d7f37.png";